<div
  class="mbl-wrap"
  role="status"
  [attr.aria-label]="message || 'Loading'"
>
  <div class="mbl-loader" aria-hidden="true">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <p class="mbl-message" *ngIf="message">{{ message }}</p>
</div>
